import React from 'react'
import { rem } from 'polished'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import CharterBundleModalUspItem from './CharterBundleModalUspItem'
import LineMaldivianIcon from 'LuxKit/Icons/line/LineMaldivianIcon'
import LineClockWithTickIcon from 'LuxKit/Icons/line/LineClockWithTickIcon'
import LineCalendarCheckIcon from 'LuxKit/Icons/line/LineCalendarCheckIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LuxuryEscapesSmallLogo from 'components/App/Header/Logo/logos/LuxuryEscapesSmallLogo'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'

export function CharterPartnerIcon() {
  return (
    <Group direction="horizontal" gap={8} verticalAlign="center" style={{ height: rem(40) }}>
      <LuxuryEscapesSmallLogo height={25} width={25} />
      <BodyText variant="large">x</BodyText>
      <LineMaldivianIcon style={{ width: rem(110), height: rem(20) }} />
    </Group>
  )
}

type CharterLearnMoreUsp = React.ComponentProps<typeof CharterBundleModalUspItem>

export const MaldivesUspGroup1: Array<CharterLearnMoreUsp> = [
  {
    title: 'Save up to 20 hours in transit*',
    description: 'Fly direct from Melbourne to Malé in less than 12 hours, with no more international stopovers.',
    icon: <LinePlaneDepartureIcon />,
    tabletIcon: <LinePlaneDepartureIcon size="XL" style={{ display: 'block' }} />,
  },
  {
    title: 'Luxury Escapes private charter',
    description: 'Weekly direct flights aboard a full-service Airbus A330-200, reserved exclusively for Luxury Escapes customers.',
    icon: <CharterPartnerIcon />,
    tabletIcon: <CharterPartnerIcon />,
  },
]
export const MaldivesUspGroup2: Array<CharterLearnMoreUsp> = [
  {
    title: 'Maximise your holiday time',
    description: 'Our overnight flights paired with early check-in & late checkout give you extra time to enjoy the Maldives.',
    icon: <LineClockWithTickIcon />,
    tabletIcon: <LineClockWithTickIcon size="XL" style={{ display: 'block' }} />,
  },
  {
    title: 'Flexible bookings',
    description: 'Experience peace of mind with free cancellation within 7 days of purchase and flexible date-change options. Conditions apply.',
    icon: <LineCalendarCheckIcon />,
    tabletIcon: <LineCalendarCheckIcon size="XL" style={{ display: 'block' }} />,
  },
]
export const MaldivesUspMobile: Array<Partial<CharterLearnMoreUsp>> = [
  {
    title: 'Save up to 20 hours in transit*',
    description: <><strong>Save up to 20 hours in transit*</strong> with nonstop flights from Melbourne to Malé in less than 12 hours.</>,
    icon: <LinePlaneDepartureIcon />,
  },
  {
    title: 'Luxury Escapes private charter',
    description: <><strong>Luxury Escapes private charter</strong> aboard a Maldivian Airlines full-service Airbus A330-200.</>,
    icon: <LineStarIcon />,
  },
  {
    title: 'Maximise your holiday time',
    description: <><strong>Maximise your holiday time</strong> with early check-in &amp; late checkout.</>,
    icon: <LineClockWithTickIcon />,
  },
  {
    title: 'Flexible bookings',
    description: <><strong>Free cancellation</strong> within 7 days and flexible date-change options. Conditions apply.</>,
    icon: <LineCalendarCheckIcon />,
  },
]
